export const areasItems = [
    //Despacho
    {
        enlace: "Despacho",
        nombre: "Secretaria de Agricultura y Desarrollo Rural (Despacho)",
        imagen2: "./img/areas/Despacho1.png",
        imagen: "./img/areas/Despacho1.png",
        DireccionGeneral: [
          {
            nombreGeneral: "Dirección General de Fomento al Crédito",
            imagenGeneral: "../img/areas/Creditos.png",
            imagenGeneral2: "../img/areas/Creditos2.png",
          },
        ],
      },
    //Administracion
  {
    enlace: "Administracion",
    nombre: "Subsecretaria de Administración y Gestión Social",
    imagen: "./img/areas/administracion.png",
    imagen2: "./img/areas/administracion.png",
    DireccionGeneral: [
      {
        enlace: "Administracion2",
        nombreGeneral: "Dirección General de Administración y Gestión Social",
        imagenGeneral: "../img/areas/Agricultura.png",
        imagenGeneral2: "../img/areas/Agricultura2.png",
      },
    ]
  },
  //Agropecuario
  {
    enlace: "Agropecuario",
    nombre: "Subsecretaria de Desarrollo Agropecuario",
    imagen: "./img/areas/agropecuario.png",
    imagen2: "./img/areas/agropecuario.png",
    DireccionGeneral: [
      {
        enlace: "Hidroagricola",
        nombreGeneral: "Dirección General de Agricultura e Infraestructura Hidroagrícola",
        imagenGeneral: "../img/areas/Agricultura.png",
        imagenGeneral2: "../img/areas/Agricultura2.png",
      },
      {
        enlace: "Maquinaria",
        nombreGeneral: "Dirección General para el Desarrollo Agropecuario y Maquinaria",
        imagenGeneral: "../img/areas/Maquinaria.png",
        imagenGeneral2: "../img/areas/Maquinaria2.png",        
      },
      {
        enlace: "Ganaderia",
        nombreGeneral: "Dirección General de Ganaderia",
        imagenGeneral: "../img/areas/Ganaderia.png",
        imagenGeneral2: "../img/areas/Ganaderia2.png",  
      },
      {
        enlace: "FomentoLechero",
        nombreGeneral: "Dirección General de Fomento Lechero",
        imagenGeneral: "../img/areas/Lechero.png",
        imagenGeneral2: "../img/areas/Lechero2.png",
      },
    ],
  },
  
//Desarrollo Rural
  {
    enlace: "Desarollo",
    nombre: "Subsecretaria de Desarrollo Rural",
    imagen: "./img/areas/rural.png",
    imagen2: "./img/areas/rural.png",
  DireccionGeneral: [
    {
      enlace: "DesarrolloRural",
      nombreGeneral: "Dirección General de Desarrollo Rural",
      imagenGeneral: "../img/areas/DirRural.png",
      imagenGeneral2: "../img/areas/DirRural2.png",
    },
    {
      enlace: "Sivicultura",
      nombreGeneral: "Dirección General de Sivicultura, Acuacultura, Fruticultura y el Maguey",
      imagenGeneral: "../img/areas/Silvicultura.png",
      imagenGeneral2: "../img/areas/Silvicultura2.png",
    },
    {
      enlace: "DesarrolloCafeticultura",
      nombreGeneral: "Dirección General de Desarrollo de la Cafeticultura",
      imagenGeneral: "../img/areas/Cafeticultura.png",
      imagenGeneral2: "../img/areas/Cafeticultura2.png",
    }

  ],
},
//Agronegocios
{
  enlace: "Agronegocios",
  nombre: "Subsecretaria de Agronegocios",
  imagen: "./img/areas/agronegocios.png",
  imagen2: "./img/areas/agronegocios.png",
DireccionGeneral: [
  {
    enlace: "Comercialización",
    nombreGeneral: "Dirección General de Comercialización y Mercadotecnia",
    imagenGeneral: "../img/areas/Mercadotecnia.png",
    imagenGeneral2: "../img/areas/Mercadotecnia2.png",
    DireccionArea: [
      {
        enlace: "ComercializacionVinculacion",
        nombreArea: "Dirección de Vinculación Empresarial",
        imagenArea: "./img/areas/Creditos.png",
        imagenArea2: "./img/areas/Creditos2.png",
      },
    ],
    DireccionArea: [
      {
        enlace: "ComercializaciónMercadotecnia",
        nombreArea: "Dirección de Mercadotecnia",
        imagenArea: "./img/areas/Creditos.png",
        imagenArea2: "./img/areas/Creditos2.png",
      },
    ],
  },
],
},
//Planeación
{
  enlace: "Planeacion",
  nombre: "Subsecretaria de Planeación y Evaluación Sectorial",
  imagen: "./img/areas/planeacion.png",
  imagen2: "./img/areas/planeacion.png",  
DireccionGeneral: [
  {
    enlace: "ProgramasEstrategicos",
    nombreGeneral: "Dirección General de Programas Estratégicos y Evaluación",
    imagenGeneral: "../img/areas/Programas.png",
    imagenGeneral2: "../img/areas/Programas2.png",
  },
  ],
  DireccionArea: [
    {
      enlace: "PlaneacionInnovacion",
      nombreArea: "Dirección de Innovación y Sistemas",
      imagenArea: "./img/areas/Creditos.png",
      imagenArea2: "./img/areas/Creditos2.png",
    },
  ],
  
   
  },
];

